import * as R from 'ramda'
import {
  all,
  put,
  select,
  fork,
  take,
  takeEvery,
} from 'redux-saga/effects'

import injectSagas from 'helpers/injectSagas'
import validations from './validations'
import getSelectors from './selectors'

import {
  runRiskValidation as runRiskValidationAction
} from './actions'

import {
  displayError
} from 'helpers/validator'

import {
  createNamedAction
} from 'helpers/ActionUtil'

import {
  createTakeEveryName,
} from 'helpers/SagaUtil'

import {
  ADD_CONFIG,
  DELETE_PART,
  RUN_RISK_VALIDATION
} from './constants'

import {
  dispatchAddRiskCheck,
  dispatchRemoveRiskCheck,
} from 'containers/Form/RiskValidation/actions'

import {
  getPath,
  getUiPath,
  combinePath
} from 'containers/Form/util'

function loadSagas(path, id) {
  const combinedPath = combinePath(path, id)
  const valuePath = getPath(path, id)
  const uiPath = getUiPath(id)
  const {
    valuesSelector,
  } = getSelectors(combinedPath, uiPath)

  const runRiskValidation = createNamedAction(valuePath, runRiskValidationAction)
  const takeEveryName = createTakeEveryName(valuePath)

  function* runRiskValidationHandler() {
    let values = yield select(valuesSelector)
    const errors = displayError(values, validations)

    yield errors
      ? put(dispatchAddRiskCheck(id))
      : put(dispatchRemoveRiskCheck(id))
  }

  function* watchRunRiskValidation() {
    yield takeEveryName(RUN_RISK_VALIDATION, runRiskValidationHandler)
  }

  function* valueChangeHandler() {
    yield put(runRiskValidation())
  }

  function* watchValueAdd() {
    yield takeEveryName(ADD_CONFIG, valueChangeHandler)
  }

  function* watchValueDelete() {
    yield takeEveryName(DELETE_PART, valueChangeHandler)
  }

  function* sagas() {
    yield all([
      fork(watchValueAdd),
      fork(watchValueDelete),
      fork(watchRunRiskValidation),
    ])
  }

  return injectSagas({ ['risk_' + combinedPath]: sagas })
}

export default loadSagas
